import React, { useState } from "react";
import {
  Modal,
  Button,
  Form,
  Input,
  Typography,
  message,
  Card,
  Space,
  Descriptions,
} from "antd";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/auth.context";
import { User } from "../../types/user.type";
import { api } from "../../api/api";

const { Title, Text } = Typography;

export default function Profile() {
  const { authState, setAuthState } = useAuth();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);

  const handleUpdateProfile = async (values: Partial<User>) => {
    const { name, username, password, phone } = values;
    const currentUser = authState.user;

    const updatedValues: Partial<User> = {};
    if (name && name !== currentUser?.name) updatedValues.name = name;
    if (username && username !== currentUser?.username)
      updatedValues.username = username;
    if (password) updatedValues.password = password;
    if (phone !== undefined && phone !== currentUser?.phone) updatedValues.phone = phone;

    if (Object.keys(updatedValues).length === 0) {
      message.info("Нет изменений для обновления.");
      return;
    }

    setConfirmLoading(true);
    try {
      const { data } = await api.put(`/user/change`, updatedValues);
      message.success("Профиль успешно обновлён.");
      setAuthState((prev) => ({ ...prev, user: data.user }));
      setIsModalOpen(false);
      setConfirmLoading(false);
    } catch (error: any) {
      setConfirmLoading(false);
      message.error(error.response?.data.error);
    }
  };

  if (!authState?.user) {
    return <Text>Пользователь не найден</Text>;
  }

  return (
    <Card style={{ maxWidth: 600, margin: "auto", marginTop: 32, padding: 24 }}>
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <Title level={2} style={{ textAlign: "center" }}>
          Профиль
        </Title>
        <Descriptions bordered column={1} size="middle">
          <Descriptions.Item label="Имя">
            {authState.user.name}
          </Descriptions.Item>
          <Descriptions.Item label="Логин">
            {authState.user.username}
          </Descriptions.Item>
          <Descriptions.Item label="Телефон">
            {authState.user.phone || "Не указан"}
          </Descriptions.Item>
          <Descriptions.Item label="Роль">
            {authState.user.role || "Не указана"}
          </Descriptions.Item>
        </Descriptions>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button type="primary" block onClick={() => setIsModalOpen(true)}>
            Изменить профиль
          </Button>
          <Button block onClick={() => navigate("/sidebar-settings")}>
            Настройки сайдбара
          </Button>
        </Space>
      </Space>

      <Modal
        title="Изменить профиль"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        confirmLoading={confirmLoading}
      >
        <Form
          layout="vertical"
          initialValues={{
            name: authState.user.name,
            username: authState.user.username,
            phone: authState.user.phone || "",
            password: "",
          }}
          onFinish={handleUpdateProfile}
        >
          <Form.Item
            name="name"
            label="Имя"
            rules={[{ required: true, message: "Введите имя" }]}
          >
            <Input placeholder="Введите ваше имя" />
          </Form.Item>
          <Form.Item
            name="username"
            label="Логин"
            rules={[{ required: true, message: "Введите логин" }]}
          >
            <Input placeholder="Введите ваш логин" />
          </Form.Item>
          <Form.Item
            name="phone"
            label="Телефон"
            tooltip="Отображается в коммерческих предложениях"
          >
            <Input placeholder="+998 XX XXX XX XX" />
          </Form.Item>
          <Form.Item
            name="password"
            label="Пароль"
            tooltip="Оставьте пустым, если не хотите менять пароль"
          >
            <Input.Password placeholder="Новый пароль" />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={confirmLoading}
            >
              Сохранить
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
}
